<template>
    <div>
    <v-dialog
        v-model="dialogSale"
        width="1300"
        persistent
        scrollable
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                small
                color="success"
                class="text-capitalize"
                v-bind="attrs"
                v-on="on"
            >Nueva venta</v-btn>
        </template>

        <v-form @submit.prevent="onSubmit" lazy-validation ref="formSale">
            <v-card :loading="loading" :disabled="loading">
                <v-card-title class="text-h5 grey lighten-2">
                    Nuevo venta
                </v-card-title>

                <v-card-text class="pt-4">
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <v-switch
                                v-model="form.credit"
                                :false-value="1"
                                :true-value="0"
                                :label="form.credit?'Crédito':'Contado'"
                            ></v-switch>
                            <v-text-field
                                label="Días de crédito *"
                                dense
                                outlined
                                v-model="form.days"
                                :rules="[rules.required]"
                                v-if="form.credit"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-checkbox
                                label="Venta rápida"
                                :false-value="0"
                                :true-value="1"
                                v-model="form.fast"
                            ></v-checkbox>
                            <v-text-field
                                label="Nombre cliente *"
                                dense
                                outlined
                                v-model="form.client"
                                :rules="[rules.required]"
                                v-if="!form.fast"
                            ></v-text-field>
                            <v-text-field
                                label="NIT / CI *"
                                dense
                                outlined
                                v-model="form.nit"
                                :rules="[rules.required]"
                                v-if="!form.fast"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-checkbox
                                label="Enviar recibo vía celular"
                                :false-value="0"
                                :true-value="1"
                                v-model="form.invoice"
                            ></v-checkbox>
                            <v-text-field
                                label="Número de celular *"
                                dense
                                outlined
                                type="number"
                                v-model="form.phone"
                                :rules="[rules.required]"
                                v-if="form.invoice"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <br>
                            <v-select
                                label="Tipo de pago"
                                outlined
                                dense
                                :items="['Efectivo', 'Qr', 'Tarjeta']"
                                v-model="form.payment"
                                :rules="[rules.required]"
                            ></v-select>
                        </v-col>
                    </v-row>

                    <!-- add barcode -->
                    <template>
                        <div class="text-center pa-4">
                            <!-- <v-btn @click="dialog = true">
                                Open Dialog
                            </v-btn> -->

                            <v-dialog
                                v-model="dialog"
                                max-width="500"
                                persistent
                            >
                                <v-card>
                                    <v-card-title class="text-h5 grey lighten-2">
                                        Escanear Código de barras.
                                    </v-card-title>

                                    <barcode
                                        @result="onScan"
                                        ref="barcodeRef"
                                        container="reader_sale"
                                    ></barcode>

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="primary"
                                        text
                                        @click="stopScan"
                                    >
                                        Cerrar
                                    </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </div>
                    </template>
                    <!-- end add barcode -->

                    <v-row>
                        <v-col cols="12" sm="6" :md="typeStore=='product' ? '5' : '7'">
                            <v-card>
                                <v-card-title>
                                    Elige los productos
                                </v-card-title>
                                <v-card-title>
                                    <v-combobox
                                        label="Buscar producto (nombre, código)"
                                        dense
                                        outlined
                                        hide-details
                                        :items="itemsProd"
                                        item-text="name_code"
                                        item-value="id"
                                        :return-object="true"
                                        v-model="resultProd"
                                        @update:search-input="searchProds($event)"
                                        @change="openDetails($event)"
                                    ></v-combobox>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        @click="startScan"
                                        color="primary"
                                        >
                                        <v-icon>mdi-barcode</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <!-- lista de productos -->
                                    <list-product-by-category @selected="openDetails" :money="money" :type-store="typeStore" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6" :md="typeStore=='product' ? '7' : '5'">
                            <v-card>
                                <v-card-title>
                                    Resumen del pedido
                                </v-card-title>
                                <v-card-text>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <v-chip
                                                            color="primary"
                                                            outlined
                                                        >
                                                            <strong>TOTAL</strong>
                                                        </v-chip>
                                                    </th>
                                                    <th colspan="3"></th>
                                                    <th><strong class="font-weight-black body-1">{{ tmpTotal }}</strong></th>
                                                    <th></th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th>
                                                        Código
                                                    </th>
                                                    <th>
                                                        Producto
                                                    </th>
                                                    <th>
                                                        Cantidad
                                                    </th>
                                                    <th>
                                                        Precio unitario
                                                    </th>
                                                    <th v-if="typeStore=='product'">
                                                        Descuento
                                                    </th>
                                                    <th>
                                                        Subtotal
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(prod, i) in productList" :key="'index_'+i">
                                                    <td>
                                                        <v-btn
                                                            icon
                                                            color="error"
                                                            @click="productList.splice(i, 1), calculateTotal()"
                                                        >
                                                            <v-icon>
                                                                mdi-delete
                                                            </v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <td>{{ prod.code }}</td>
                                                    <td>{{ prod.name }} {{ prod.complements.multi.length>0 ? showComplementsMulti(prod.complements.multi) : '' }} {{ prod.complements.only.length>0 ? showComplementsOnly(prod.complements.only) : '' }}</td>
                                                    <td>
                                                        <span v-if="typeStore=='gastronomic' || typeStore=='service'">{{ prod.quantity }}</span>
                                                        <v-text-field
                                                            v-model="productList[i].quantity"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                            v-if="typeStore=='product'"
                                                        ></v-text-field>
                                                    </td>
                                                    <td>
                                                        <span v-if="typeStore=='gastronomic' || typeStore=='service'">{{ prod.price_normal }}</span>
                                                        <v-text-field
                                                            v-model="productList[i].price_normal"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                            v-if="typeStore=='product'"
                                                        ></v-text-field>
                                                    </td>
                                                    <td v-if="typeStore=='product'">
                                                        <v-text-field
                                                            v-model="productList[i].discount"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                        ></v-text-field>
                                                    </td>
                                                    <td class="text-right">
                                                        <v-text-field
                                                            v-model="productList[i].price"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                            v-if="typeStore=='gastronomic' || typeStore=='service'"
                                                        ></v-text-field>
                                                        <span v-if="typeStore=='product'">{{ prod.price }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot v-if="typeStore=='product'">
                                                <tr>
                                                    <td colspan="6" class="text-right">
                                                        <strong>Subtotal</strong>
                                                    </td>
                                                    <td class="text-right">{{ tmpTotal }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="6" class="text-right">
                                                        <strong>Descuento general</strong>
                                                    </td>
                                                    <td class="text-right">
                                                        <v-text-field
                                                            v-model="tmpDiscount"
                                                            dense
                                                            outlined
                                                            hide-details
                                                            type="number"
                                                            min="0"
                                                            @input="calculateTotal()"
                                                            style="width: 100px;"
                                                            class="text-right"
                                                        ></v-text-field>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="6" class="text-right">
                                                        <strong>TOTAL</strong>
                                                    </td>
                                                    <td class="text-right">{{ tmpTotal - tmpDiscount }}</td>
                                                </tr>
                                            </tfoot>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogSale = false"
                        :disabled="loading"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        type="submit"
                        :loading="loading"
                        @click="showOptionPrint = false"
                    >
                        Registrar venta
                    </v-btn>
                    <v-btn
                        color="primary"
                        type="submit"
                        :loading="loading"
                        @click="showOptionPrint = true"
                    >
                        Registrar e imprimir
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>

    <!-- dialog -->
    <v-dialog
        v-model="dialogProd"
        width="500"
        scrollable
        :fullscreen="$vuetify.breakpoint.smAndDown"
        transition="dialog-bottom-transition"
        persistent
    >
        <v-skeleton-loader
            v-if="loadProd"
            class="white"
            type="card-avatar, article, actions"
        ></v-skeleton-loader>
        <v-card
            v-else
            class="mx-auto"
        >
            <v-overlay
                absolute
                :value="overlayProd"
                opacity=".8"
            >
                <v-progress-circular
                    indeterminate
                    size="64"
                    color="success"
                ></v-progress-circular>
            </v-overlay>
            <v-fab-transition>
                <v-btn
                    absolute
                    right
                    fab
                    small
                    style="top: 10px;"
                    @click="dialogProd=!dialogProd, loadProd=!loadProd, resultProd=''"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-fab-transition>

            <v-card-text class="pb-5 px-0">
                <v-card-title class="pa-0">
                    <v-carousel
                        height="auto"
                        class="simple-carousel"
                        :show-arrows="(galleryProd.length<=0)?false:true"
                        hide-delimiters
                        style="min-height: 250px;"
                        v-if="bannerProd != 'none'"
                    >
                        <v-carousel-item
                            class="white"
                            contain
                        >
                            <v-img
                                :src="bannerProd"
                                :lazy-src="bannerProd"
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-carousel-item>
                        <v-carousel-item
                            v-for="(img, j) in galleryProd" :key="j"
                            class="white"
                            contain
                        >
                            <v-img
                                :src="img.img"
                                :lazy-src="img.img"
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-carousel-item>
                    </v-carousel>
                    <div class="px-4 py-2" style="width:100%">
                        {{ nameProd }}
                    </div>

                </v-card-title>

                <div class="px-5 mb-5" v-if="descriptionProd" :style="{'fontSize':'16px'}" v-html="descriptionProd"></div>

                <template v-for="(row, j) in optionsProd">
                    <v-card-title class="py-3">
                        {{ row.title }}
                    </v-card-title>
                    <v-alert
                        :key="j+1*150"
                        dense
                        tile
                        outlined
                        type="error"
                        v-if="showAlertRequired && row.isRequired"
                    >Debe seleccionar una opción para continuar</v-alert>
                    <!-- multiple -->
                    <v-list :key="j+10" v-if="row.type == 'multiple'">
                        <!-- select quantity -->
                        <template dense>
                            <v-list-item v-for="(opt) in row.values" :key="opt.name">
                                <v-list-item-content>
                                    <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                </v-list-item-content>

                                <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                    <v-btn
                                        small
                                        :disabled="opt.quantity<=1"
                                        @click="opt.quantity -= 1, changeRespMultiple()"

                                    >
                                        <v-icon dark>
                                            mdi-minus
                                        </v-icon>
                                    </v-btn>
                                    <v-sheet
                                        height="28"
                                        width="60"
                                        class="sheet-cant"
                                    >
                                        {{ opt.quantity }}
                                    </v-sheet>
                                    <v-btn
                                        small
                                        @click="opt.quantity += 1, changeRespMultiple()"
                                    >
                                        <v-icon dark>
                                            mdi-plus
                                        </v-icon>
                                    </v-btn>
                                </div>

                                <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${(row.quantities)?(opt.price*quantity):opt.price}:${opt.quantity}`"></span>

                                <v-list-item-action>
                                    <v-checkbox
                                        v-model="row.tmpVal"
                                        :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                        color="primary"
                                        :disabled=" ((row.tmpVal).includes(`${opt.name.replace(' ', '-')}_${opt.price}`)) ? false : ((row.tmpVal).length >= row.select) "
                                        @change="changeRespMultiple"
                                    ></v-checkbox>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list>
                    <!-- multiple end -->
                    <!-- only -->
                    <v-list :key="j+20" v-if="row.type == 'only'">
                        <v-list-item-group
                            v-model="row.tmpValOnly"
                            active-class=""
                            @change="changeRespOnly"
                        >
                        <v-list-item v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+((row.quantities)?(opt.price*quantity):opt.price)">
                            <template v-slot:default="{ active }">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-icon color="primary" v-if="active">
                                            mdi-circle-slice-8
                                        </v-icon>
                                        <v-icon v-else>
                                            mdi-checkbox-blank-circle-outline
                                        </v-icon>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                    <!-- only end -->
                </template>

                <v-divider></v-divider>

                <div class="px-3 pt-5">
                    <v-textarea
                        outlined
                        :placeholder="'Dato extra'"
                        color="primary"
                        rows="3"
                        v-model="dataExtra"
                    ></v-textarea>
                </div>

            </v-card-text>

            <v-card-actions class="pa-actions">
                <!-- product -->
                <v-row no-gutters align="center" v-if="typeProd=='product'">
                    <v-col cols="6">
                        <div class="d-flex align-center">
                            <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                <v-icon dark>
                                    mdi-minus
                                </v-icon>
                            </v-btn>
                            <v-text-field
                                placeholder="Cantidad"
                                color="primary"
                                outlined
                                dense
                                type="number"
                                min="1"
                                step="1"
                                :max="stock"
                                hide-details
                                v-model="quantity"
                                style="width:100px;max-width:100px;"
                                @input="changeQuantity($event)"
                            ></v-text-field>
                            <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                <v-icon dark>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <template>
                            <v-btn
                                large
                                block
                                rounded
                                color="primary"
                                @click="addToCart"
                                class="text-capitalize"
                            >
                                <strong>Agregar {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                            </v-btn>
                        </template>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- end dialog -->

    <!-- dialog cash -->
    <v-dialog
        v-model="dialogPrint"
        persistent
        max-width="350"
    >
        <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
                <v-btn
                    color="primary"
                    block
                    x-large
                    target="_blank"
                    class="mb-4"
                    :href="`/admin/print-internalsale/r/${internalSaleId}`"
                >Imprimir Recibo</v-btn>
                <v-btn
                    color="primary"
                    block
                    x-large
                    target="_blank"
                    :href="`/admin/print-internalsale/c/${internalSaleId}`"
                >Imprimir Comanda</v-btn>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="dialogPrint = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- END dialog cash -->
    </div>
</template>

<script>
export default {
    data: () => ({
        dialogSale: false,
        itemsProd: [],
        resultProd: '',
        form: {
            credit: 0,
            days: '',
            fast: 1,
            client: '',
            nit: '',
            invoice: 0,
            phone: '',
            products: [],
            total: 0,
            payment: 'Efectivo'
        },
        loading: false,
        /**prod */
        overlayProd: false,
        loadProd: true,
        dialogProd: false,
        prodId: '',
        bannerProd: '',
        galleryProd: [],
        nameProd: '',
        codeProd: '',
        typeProd: '',
        descriptionProd: '',
        optionsProd: [],
        quantity: 1,
        price: null,
        priceNormal: null,
        stock: 500,
        dataExtra: '',
        respMultiple: [],
        respMultipleVal: 0,
        respOnly: [],
        respOnlyVal: 0,
        showRequired: false,
        showAlertRequired: false,
        money: 'Bs.',
        productList: [],
        tmpTotal: 0,
        tmpDiscount: 0,
        rules: {
            required: value => !!value || 'Requerido.'
        },
        dialog: false,
        lastScanTime: 0,
        scanDelay: 2000,
        // imprimir
        showOptionPrint: false,
        dialogPrint: false,
        internalSaleId: ''
    }),
    props:['slug', 'typeStore'],
    methods: {
        async searchProds(e) {
            if (typeof e == 'string') {
                await axios.get('/admin/prods-search?q=' + e + '&store=' + this.slug)
                .then((response) => {
                    // console.log(response);
                    this.itemsProd = response.data
                })
                .catch((error) => {
                    console.log(error);
                })
            }
        },
        changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 500);
        },
        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        openDetails(e) {
            const typeInput = typeof e == 'string' ? 'code' : 'id'
            
            const id = typeInput=='id' ? e.id : e
            this.loadProd = true
            this.optionsProd = []
            this.respMultipleVal = 0
            this.respOnlyVal = 0
            this.respMultiple = []
            this.respOnly = []
            // this.dialogProd = true
            axios.get(`/show-product/${id}?store=${this.slug}&type=${typeInput}`)
            .then((response) => {
                // console.log(response.data);
                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.codeProd = response.data.code??'-'
                this.typeProd = response.data.type
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpVal = JSON.parse(element.values)
                        var multiRequired = []
                        var onlyRequired = undefined
                        tmpVal.forEach(val => {
                            val.quantity = 1
                        });
                        if (element.type == 'multiple') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    // multiRequired.push(`${val.name}:${val.price}:${val.quantity}`)
                                    multiRequired.push(`${val.name.replace(' ', '-')}_${val.price}`)
                                    setTimeout(() => {
                                        this.changeRespMultiple()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        if (element.type == 'only') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    onlyRequired = val.name+':'+val.price
                                    setTimeout(() => {
                                        this.changeRespOnly()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        // const selectRequired = `${opt.name.replace(' ', '-')}_${opt.price}`
                        this.optionsProd.push({
                            title: element.title,
                            type: element.type,
                            values: tmpVal,
                            select: element.select,
                            tmpVal: multiRequired,
                            tmpValOnly: onlyRequired,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false,
                            quantities: (element.quantities)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price
                this.priceNormal = response.data.price??0;
                this.quantity = 1
                if (response.data.stock > 0) {
                    this.stock = response.data.stock
                }

                switch (this.typeStore) {
                    case 'product':
                        setTimeout(() => {
                            this.addToCart()
                        }, 300);
                        break;
                
                    default:
                        this.dialogProd = true
                        setTimeout(() => {
                            this.loadProd = false
                        }, 800);
                        break;
                }
                
            })
            .catch((error) => {
                console.log(error);
            })
        },
        changeQuantity(event) {
            if (+event <= 1) {
                this.quantity = 1
            }
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: this.btnColor,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                    }
                })
            }
        },
        updateQuantitysComplements() {
            this.optionsProd.forEach(element => {
                if (element.quantities) {
                    if (element.tmpValOnly) {
                        let tmp = element.tmpValOnly.split(':')
                        element.values.forEach(item => {
                            if (item.name == tmp[0]) tmp[1] = item.price
                        });
                        tmp[1] = tmp[1]*this.quantity
                        element.tmpValOnly = tmp.join(':')
                    }
                    if (element.tmpVal.length > 0) {
                        element.tmpVal.forEach(val => {
                            const selectedId = document.getElementById(val)
                            const dataSelected = selectedId.getAttribute('data-details')
                            let tmp2 = dataSelected.split(':')
                            element.values.forEach(item => {
                                if (item.name == tmp2[0]) tmp2[1] = item.price
                            });
                            tmp2[1] = tmp2[1]*this.quantity
                            selectedId.setAttribute('data-details', tmp2.join(':'))
                        });
                    }
                }
            });
            this.changeRespOnly()
            this.changeRespMultiple()
        },
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }

            this.updateQuantitysComplements()

            this.changeQuantity(this.quantity)
        },
        addToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true
            const cart = {
                    prodId: this.prodId,
                    code: this.codeProd,
                    name: this.nameProd,
                    // price: this.price,
                    price_normal: this.priceNormal,
                    price: (this.quantity * this.price) + this.respMultipleVal + this.respOnlyVal,
                    priceNormal: this.priceNormal,
                    quantity: this.quantity,
                    discount: 0,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    }
                }

            // console.log(cart);
            this.productList.push(cart)

            setTimeout(() => {
                this.overlayProd = false
                this.dialogProd = false
            }, 300);
            setTimeout(() => {
                this.$notify.success('Producto agregado correctamente.');
                this.resultProd = ''
                this.itemsProd = []
                this.calculateTotal()
            }, 500);
        },

        showComplementsMulti(txt) {
            let result = ''
            let tmpTxt = []
            txt.forEach(el => {
                tmpTxt = el.split(':')
                result += (' '+tmpTxt[0]+'x'+tmpTxt[2])
            });
            return result
        },
        showComplementsOnly(txt) {
            let result = ''
            let tmpTxt = []
            txt.forEach(el => {
                tmpTxt = el.split(':')
                result += (' '+tmpTxt[0])
            })
            return result
        },
        calculateTotal() {
            this.tmpTotal = 0
            this.productList.forEach(element => {
                this.tmpTotal += (((+element.price_normal) * (+element.quantity)) - (+element.discount))
                element.price = (((+element.price_normal) * (+element.quantity)) - (+element.discount))
            })
            this.tmpTotal = this.tmpTotal.toFixed(2)
        },
        /**
         * submit
         */
        async onSubmit() {
            if (this.$refs.formSale.validate() && this.productList.length > 0) {
                this.loading = true
                this.form.products = this.productList
                this.form.total = this.tmpTotal
                this.form.gralDiscount = this.tmpDiscount

                await axios.post('/admin/internal-sale', this.form)
                .then((response) => {
                    // console.log(response);
                    if (response.data[0] === 'ok') {
                        this.$notify.success('Venta registrada con exito.')
                        this.form = {
                            credit: 0,
                            days: '',
                            fast: 0,
                            client: '',
                            nit: '',
                            invoice: 0,
                            phone: '',
                            products: [],
                            total: 0,
                            payment: 'Efectivo'
                        }
                        this.productList = []
                        this.tmpTotal = 0
                        // this.$refs.formSale.reset()
                        this.dialogSale = false
                        if (this.showOptionPrint) {
                            this.internalSaleId = response.data[1]
                            if (this.typeStore == 'product') {
                                window.open(`/admin/print-internalsale/r/${this.internalSaleId}`, '_blank');
                            } else {
                                this.dialogPrint = true
                            }
                        }
                    }
                    this.loading = false
                })
                .catch((error) => {
                    // console.log(error);
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            } else {
                this.$notify.info('Por favor complete todos los campos requeridos.')
            }
        },
        async onScan(decodedText, decodedResult) {
            const currentTime = new Date().getTime();
            if (currentTime - this.lastScanTime > this.scanDelay) {
                this.lastScanTime = currentTime;

                // console.log(decodedText);
                let res = await axios.get(`/admin/prods-search?q=${decodedText}`);

                if(res.data.length > 0) {
                    let res2 = await axios.get(`/show-product/${res.data[0].id}?store=${this.slug}`);

                    let {id,code,name,price} = res2.data;
                    const cart = {
                        prodId: id, code: code, name: name, price: price,
                        priceNormal: price, quantity: 1,
                        extra: [], complements: { multi: [], only: [] }
                    }

                    this.productList.push(cart);
                    setTimeout(() => {
                        this.overlayProd = false
                        this.dialogProd = false
                    }, 300);
                    setTimeout(() => {
                        this.$notify.success('Producto agregado correctamente.');
                        this.resultProd = ''
                        this.calculateTotal()
                    }, 500);
                }

            }
        },
        startScan() {
            this.$refs.barcodeRef?.start();
            this.dialog = true;
        },
        stopScan () {
            this.$refs.barcodeRef.stop();
            this.dialog = false;
        }
    }
}
</script>
